import { render, staticRenderFns } from "./BtnRetornarPagamento.vue?vue&type=template&id=4ba73d3c"
import script from "./BtnRetornarPagamento.vue?vue&type=script&lang=js"
export * from "./BtnRetornarPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports